
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { EUploadStatus } from "../@types/Upload";

export interface PageState {
  uploader: {
    status: EUploadStatus,
    uploadedUrl: string;
    file: {
      name: string;
      size: number;
    }
  }
}

const initialState: PageState = {
  uploader: {
    status: EUploadStatus.NoFileSelected,
    uploadedUrl: '',
    file: {
      name: '',
      size: 0
    }
  }
};

export const TranslatePageSlice = createSlice({
  name: "pageTranslate",
  initialState,
  reducers: {
    SetUploadStatus(state, action: PayloadAction<EUploadStatus>) { state.uploader.status = action.payload; },
    SetUploadedUrl(state, action: PayloadAction<string>) { state.uploader.uploadedUrl = action.payload; },
    SetUploadedFile(state, action: PayloadAction<ISetUploadedFile>) {
      state.uploader.file.name = action.payload.name;
      state.uploader.file.size = action.payload.size;
    }
  }
});

export const { 
  SetUploadStatus, SetUploadedUrl, SetUploadedFile
} = TranslatePageSlice.actions;

export default TranslatePageSlice.reducer;

export interface ISetUploadedFile {
  name: string;
  size: number;
}